import React from 'react'
import { IconPencil, IconEraser, IconDownload, IconFileUpload, IconTrash } from '@tabler/icons-react'
// import CreateProjectViaFileUpload from '../organisms/dialogs/CreateProjectViaFileUpload'
// import { useNavigate } from 'react-router'

interface ToolbarButtonProps {
  icon: React.ReactNode
  onClick?: () => void
  isActive?: boolean
  isDisabled?: boolean
  className?: string
  noHover?: boolean
}

const ToolbarButton: React.FC<ToolbarButtonProps> = ({
  icon,
  onClick,
  isActive = false,
  isDisabled = false,
  className,
  noHover = false,
}) => {
  return (
    <button
      className={`size-6 flex items-center justify-center rounded-full transition-colors
        ${isActive ? 'bg-orange-500' : 'bg-transparent'}
        ${isDisabled ? 'cursor-not-allowed opacity-50' : !noHover ? 'hover:opacity-80' : ''}
        ${className || ''}`}
      onClick={onClick}
      disabled={isDisabled}
    >
      <div className="size-4 flex items-center justify-center p-1">{icon}</div>
    </button>
  )
}

interface VerticalToolbarProps {
  onPencil?: () => void
  onEraser?: () => void
  onDownload?: () => void
  onAdjust?: () => void
  onShare?: () => void
  onPin?: () => void
  onDelete?: () => void
  onUpload?: () => void
  isDrawing?: boolean
  hasSelectedFeatures?: boolean
  isGuideTourActive?: boolean
}

export const VerticalToolbar: React.FC<VerticalToolbarProps> = ({
  onPencil,
  onEraser,
  onDownload,
  onAdjust,
  onShare,
  onPin,
  onDelete,
  onUpload,
  hasSelectedFeatures = false,
  isDrawing = false,
  isGuideTourActive = false,
}) => {
  // const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  // const openUploadModal = () => setIsModalOpen(!isModalOpen)

  // Determine which buttons to show based on drawing state, guide state, or if features are selected
  const shouldShowAllButtons = isDrawing || isGuideTourActive || hasSelectedFeatures

  return (
    <div
      className={`tool-bar flex h-10 items-center gap-2 py-0 pl-0 pr-2 ${
        shouldShowAllButtons ? 'rounded-full bg-gray-900' : ''
      }`}
    >
      {/* Group for Upload and Pencil buttons with background */}
      <div className="flex h-full w-[72px] items-center justify-center gap-2 rounded-full bg-gray-800 p-2">
        {/* Upload File button - always visible */}
        <ToolbarButton
          icon={<IconFileUpload size={16} stroke={1.5} className="text-gray-50" />}
          onClick={onUpload}
          isDisabled={!onUpload}
          className="vertical-toolbar-upload"
        />

        {/* Pencil button - always visible */}
        <ToolbarButton
          icon={<IconPencil size={16} stroke={1.5} className="text-gray-50" />}
          onClick={onPencil}
          isActive={isDrawing}
          className="vertical-toolbar-pencil"
          noHover={true}
        />
      </div>

      {/* Conditional buttons - only shown when drawing or during guide */}
      {shouldShowAllButtons && (
        <>
          <ToolbarButton
            icon={<IconEraser size={16} stroke={1.5} className="text-gray-50" />}
            onClick={onEraser}
            className="vertical-toolbar-eraser"
          />
          <ToolbarButton
            icon={<IconDownload size={16} stroke={1.5} className="text-gray-50" />}
            onClick={onDownload}
            isDisabled={!hasSelectedFeatures}
            className="vertical-toolbar-download"
          />

          {/* Separator */}
          <div className="relative h-6 w-3 shrink-0">
            <div className="absolute inset-y-0 left-1/2 w-px -translate-x-1/2 bg-gray-800"></div>
          </div>

          <ToolbarButton
            icon={<IconTrash size={16} stroke={1.5} className="text-gray-50" />}
            onClick={onDelete}
            className="vertical-toolbar-delete"
          />
        </>
      )}

      {/* <CreateProjectViaFileUpload isOpen={isModalOpen} onOpenChange={setIsModalOpen} /> */}
    </div>
  )
}
